import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import HealthClassCalcStackedButton from '../HealthClassCalculator/HealthClassCalcStackedButton';
import HealthClass from "./HealthClass";

export default function TermInsuranceHealthTools(props) {
  const { toolName, title, onHealthClassChange } = props;

  const [healthClass, setHealthClass] = useState(null);
  const [healthClassName, setHealthClassName] = useState('');

  const handleHealthClassChange = (event) => {
    setHealthClass(event);
  };

  useEffect(() => {
    getHealthClassNameFromCode(props.healthClass);
  }, []);

  useEffect(() => {
    if (healthClass) {
      onHealthClassChange(healthClass);
      getHealthClassNameFromCode(healthClass);
    }
  }, [healthClass]);

  const getHealthClassNameFromCode = (hcCode) => {
    const healthClassMap = HealthClass();
    const currentHealthClass = healthClassMap.find((hc) => hc.value === hcCode.toUpperCase());
    if (currentHealthClass) {
      setHealthClassName(currentHealthClass.label);
    }
  };

  return (
    <HealthClassCalcStackedButton
      type='quote-screen'
      condensed
      toolName={toolName}
      title={title}
      currentHealthClass={healthClassName}
      onHealthClassChange={handleHealthClassChange}
    />
  );
};

TermInsuranceHealthTools.propTypes = {
  toolName: PropTypes.string,
  title: PropTypes.string,
  healthClass: PropTypes.string,
  onHealthClassChange: PropTypes.func,
};
